import React, { useRef } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Camera, Trash2, LinkIcon } from "lucide-react";

export const TF = ({ label, value, onChange, placeholder, hint, type = "text", testid }) => (
  <div>
    <Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>
    <Input data-testid={testid} type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="mt-1.5" />
    {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
  </div>
);

export const TA = ({ label, value, onChange, placeholder, hint, testid }) => (
  <div>
    <Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>
    <Textarea data-testid={testid} value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="mt-1.5" />
    {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
  </div>
);

export const SW = ({ label, checked, onChange, hint, testid }) => (
  <div className="flex items-center justify-between rounded-xl border border-border bg-muted/30 p-4">
    <div>
      <p className="text-sm font-medium">{label}</p>
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </div>
    <Switch data-testid={testid} checked={!!checked} onCheckedChange={onChange} />
  </div>
);

export function PhotoField({ label, uploaded, url, onUpload, onUrl, onClear, uploading, hint, testid }) {
  const ref = useRef(null);
  const preview = uploaded || url;
  return (
    <div>
      <Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
      <div className="mt-2 flex items-start gap-3">
        <div className="h-24 w-32 shrink-0 overflow-hidden rounded-xl border border-border bg-muted">
          {preview ? <img src={preview} alt={label} className="h-full w-full object-cover" /> : <div className="flex h-full items-center justify-center text-[10px] text-muted-foreground">Belum ada</div>}
        </div>
        <div className="flex-1 space-y-2">
          <div className="flex gap-2">
            <Button type="button" data-testid={`${testid}-upload`} onClick={() => ref.current?.click()} variant="outline" size="sm" disabled={uploading} className="gap-1">
              <Camera className="h-4 w-4" /> {uploading ? "Mengunggah..." : "Unggah"}
            </Button>
            {uploaded && (
              <Button type="button" data-testid={`${testid}-clear`} onClick={onClear} variant="ghost" size="sm" className="gap-1 text-red-500 hover:text-red-600">
                <Trash2 className="h-4 w-4" /> Hapus
              </Button>
            )}
          </div>
          <div className="relative">
            <LinkIcon className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
            <Input data-testid={`${testid}-url`} value={url ?? ""} onChange={(e) => onUrl(e.target.value)} placeholder="atau tempel URL gambar" className="pl-8 text-xs" />
          </div>
          <p className="text-[11px] text-muted-foreground">Foto yang diunggah diprioritaskan di atas URL.</p>
        </div>
        <input ref={ref} type="file" accept="image/*" className="hidden" data-testid={`${testid}-input`} onChange={(e) => { const f = e.target.files?.[0]; if (f) onUpload(f); e.target.value = ""; }} />
      </div>
    </div>
  );
}
